export const formatByThree = (code = '') => {
	if (typeof code !== 'string') return '';
	return code.match(/.{1,3}/g) && code.match(/.{1,3}/g).join(' - ') || '';
}



// WEBPACK FOOTER //
// ./src/components/Modal/LoginQR/utils.js